import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from 'redux-saga';
import authReducer from "./authSlice";
import surveyReducer from "../pages/surveys/reducers";
import userReducer from "../pages/users/reducers";
import passwordReducer from "../pages/passwords/reducers";
import * as LoginSaga from './login/sagas';
import * as SurveySaga from '../pages/surveys/sagas';
import * as UserSaga from '../pages/users/sagas';
import * as PasswordsSaga from '../pages/passwords/sagas';


// Step 3: Create saga middleware
const sagaMiddleware = createSagaMiddleware();

const sagas = {
  ...LoginSaga,
  ...SurveySaga,
  ...UserSaga,
  ...PasswordsSaga,
};


const store = configureStore({
  reducer: {
    client: authReducer,
    survey: surveyReducer,
    user: userReducer,
    password: passwordReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ['callbacks.success', 
          'callbacks.error', 
          'meta.callback', 
          'data.callback', 
          'data.success',
          'data.error'
        ],
      },
    }).concat(sagaMiddleware),
});

for (let saga in sagas) {
  sagaMiddleware.run(sagas[saga])
};

export default store;